import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as UnionIconSvg } from '../../assets/union-icon.svg';

export const UnionIcon = (props: Partial<CustomIconComponentProps>) => {
  return <Icon component={UnionIconSvg} {...props} />;
};
